import { BASE_URL, OCTA_AUTH_URL, OCTA_LOGOUT_URL } from 'api/constants';

export const config = {
    logoutRedirectUri: '/',
    loginRedirectUri: '/',
    hasLoginPage: false,
    authType: 'okta',
    urls: {
        api: BASE_URL,
        oktaUrl: OCTA_AUTH_URL,
        oktaLogout: OCTA_LOGOUT_URL,
    }
};
